import './page.scss';

// Components
import '@/components/product/product-description/product-description';
import '@/components/product/product-details/product-details';
import '@/components/product/product-gallery/product-gallery';

// Sections
import '@/sections/product-recommendations/product-recommendations';
